<template>
  <div class="container editable-info">
    <div
      class="info-wrapper"
      v-if="!editMode"
    >
      <div class="info">{{value}}</div>
      <el-button
        type="iconButton"
        icon="h-icon-edit"
        :title="$t('management.menu.edit')"
        @click="changeToEdit"
      ></el-button>
    </div>
    <div
      class="edit-wrapper"
      v-if="editMode"
    >
      <div class="input-wrapper">
        <el-form @submit.prevent.native="false">
          <el-input
            style="width: 100%"
            v-model="newValue"
            :clearable="true"
          ></el-input>
        </el-form>
      </div>
      <div class="button-wrapper">
        <el-button
          type="iconButton"
          icon="h-icon-right"
          :title="$t('common.confirmBtn_text')"
          @click="finishEdit"
        ></el-button>
        <el-button
          type="iconButton"
          icon="h-icon-close"
          :title="$t('common.cancelBtn_text')"
          style="margin-left: 0"
          @click="cancelEdit"
        ></el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'editable-info',
  props: {
    value: String,
    mode: {
      type: String,
      default: 'name'
    }
  },
  data () {
    return {
      newValue: '',
      oldValue: '',
      editMode: false
    }
  },
  methods: {
    _validate () {
      if (this.mode === 'name') {
        if (this.newValue === '') {
          this.$message.error(this.$t('common.require_valid_error'))
          return false
        }
        if (/[\\/:*?"<|'&%>]/.test(this.newValue)) {
          this.$message.error(this.$t('common.char_valid_error'))
          return false
        }
        if (this._getByteLen(this.newValue) > 32) {
          this.$message.error(this.$t('common.max_32_valid_error'))
          return false
        }
        return true
      } else if (this.mode === 'url') {
        if (/[\u4E00-\u9FA5\uF900-\uFA2D]/.test(this.newValue)) {
          this.$message.error(this.$t('common.no_chinese'))
          return false
        }
        return true
      } else {
        return true
      }
    },
    _getByteLen (val) {
      let len = 0
      for (let i = 0; i < val.length; i++) {
        // let a = val.charAt(i)
        // if (a.match(/[^\x00-\xff]/ig) !== null) {
        //   len += 2
        // } else {
        //   len += 1
        // }
      }
      return len
    },
    changeToEdit () {
      this.editMode = true
      this.newValue = this.value || ''
      this.oldValue = this.value
    },
    cancelEdit () {
      this.editMode = false
    },
    finishEdit () {
      if (!this._validate()) {
        return
      }
      if (this.newValue !== this.oldValue) {
        this.$emit('input', this.newValue)
        this.$emit('change', this.newValue)
      }
      this.editMode = false
    }
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
@import "~assets/styles/mixin.less";

.editable-info.container {
  width: 100%;
  height: 32px;
  position: relative;
  .info-wrapper {
    width: 100%;
    height: 100%;
    line-height: 32px;
    .info {
      max-width: calc(~"100% - 38px");
      .text-over();
      display: inline-block;
      vertical-align: top;
    }
    .el-button {
      display: none;
    }
    &:hover {
      .el-button {
        display: inline-block;
      }
    }
  }
  .edit-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-right: 74px;
    .button-wrapper {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
}
</style>
